import React from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import HilfeAdornment from './HilfeAdornment';

const CustomTextFieldNGX = (props) => {

  return (
    <TextField
      id={props.id}
      fullWidth
      error={errorState(props) !== true}
      label={props.label}
      value={props.data.value}
      placeholder={props.placeholder}
      //variant="filled"
      multiline={props.multiline}
      rows={props.rows}
      type={props.type}
      disabled={props.disabled}
      onChange={
        (e)=>{props.updaterValue(e.target.value)}
      }
      onBlur = {
        () => props.updaterTouch(true)
      }
      required={props.required}
      InputProps={inputProps(props)}
      helperText={
        helperText(props)
      }
    />
  )

}

const inputProps = (props) => {
  let obj = {
    endAdornment: <HilfeAdornment hilfe={props.hilfe} />,
  }
  if (props.startAdornment) {
    obj['startAdornment'] = <InputAdornment position="start">{props.startAdornment}</InputAdornment>
  }
  if (props.endAdornment) {
    obj['endAdornment'] = <InputAdornment position="end">{props.endAdornment}</InputAdornment>
  }
  if (props.inputProps) {
    obj = {obj, ...props.inputProps}
  }

  return obj;
}

const errorState = (props) => {
  let valid = props.validator().valid;

  if ( !props.data.hasOwnProperty("touched") ) {
    return valid;
  }

  if ( props.data.touched ) {
    return valid;
  }

  return true;
}

const helperText = (props) => {
  let msg = props.validator().message;

  if ( !props.data.hasOwnProperty("touched") ) {
    return msg;
  }

  if ( props.data.touched ) {
    return msg;
  }

  return [];
}

export default CustomTextFieldNGX;
